import { Box, Typography } from '@mui/material';
import React, { useRef } from 'react';
import CustomerNameTagButton from '../../../components/CustomerNameTagButton';
import { BooleanInput, FormDataConsumer, Labeled, TextInput, maxLength, minValue, required } from 'react-admin';
import DateTimeInputUTC from '../../../components/DateTimeInputUTC';
import { RichTextInputCustom } from '../../../components/RichTextInputCustom';
import { addMinuteToDate } from '../../../lib';

const richTextSx = {
  width: 'auto',
  '& .ql-editor': {
    minHeight: 200
  }
};

const labeledWidthSx = {
  width: '70%'
};

const charCounterSx = {
  top: '35%',
  right: '1%',
  width: 'auto',
  fontSize: 12,
  opacity: 0.75,
  fontFamily: 'Helvetica',
  textAlign: 'end',
};

const FormNotification: React.FC<{ formData?: any }> = ({ formData }) => {
  const titleInputRef = useRef<HTMLInputElement>(null);
  const pushInputRef = useRef<HTMLInputElement>(null);

  const [counterCharSms, setCounterCharSms] = React.useState(0);
  const [counterCharPush, setCounterCharPush] = React.useState(0);

  const MAX_LENGTH_SMS = 160;
  const MAX_LENGTH_PUSH = 130;

  const nowDatePlus10Minutes = () => addMinuteToDate(new Date(), 10);

  const counterCharInput = (inputName: string, valueInput: string) => {
    const valueFormater = valueInput.length
    switch (inputName) {
      case 'sms':
        setCounterCharSms(valueFormater);
        break;

      case 'push':
        setCounterCharPush(valueFormater);
        break;

      default:
        break;
    }
  }

  return (
    <>
      <BooleanInput source="hasNotification" label="Ativar notificação" defaultValue={false} />
      {
        formData?.hasNotification &&
        <>
          <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
            <TextInput
              source="notification.title"
              label="Título"
              InputProps={{ autoComplete: 'off', inputRef: titleInputRef }}
              // validate={[required(), maxLength(65)]}
              style={{ minWidth: 500 }}
            />
            <Box sx={{ mt: 2 }}>
              <CustomerNameTagButton inputRef={titleInputRef} />
            </Box>
          </Box>
          <Box sx={richTextSx}>
            <Labeled label="Descrição: ">
              <RichTextInputCustom
                source="notification.body"
                label="Essa mensagem pode conter formatações e será exibida no aplicativo, na tela de notificação. Ela NÃO será enviada na notificação PUSH e no SMS"
                validate={required()}
              />
            </Labeled>
          </Box>
          <Labeled label="Enviar via: " fullWidth>
            <>
              {/* <BooleanInput source="sms" label="SMS" /> */}
              <BooleanInput source="notification.pushNotification" label="Notificação no aplicativo" />
            </>
          </Labeled>
          <FormDataConsumer>
            {({ formData }) => {
              if (formData.notification?.sms) {
                return (
                  <Labeled label="Esta mensagem será enviada no SMS: " sx={labeledWidthSx}>
                    <>
                      <TextInput
                        style={{ width: '100%' }}
                        source="notification.smsMessage"
                        label="Mensagem SMS"
                        validate={[required(), maxLength(MAX_LENGTH_SMS)]}
                        inputProps={{ autoComplete: 'off' }}
                        onChange={(e) => counterCharInput('sms', e.target.value)}
                      />
                      <Box component="span" sx={charCounterSx}>{counterCharSms}/{MAX_LENGTH_SMS}</Box>
                    </>
                  </Labeled>
                );
              }
            }}
          </FormDataConsumer>
          <FormDataConsumer>
            {({ formData }) => {
              if (formData.notification?.pushNotification) {
                return (
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, width: '100%' }}>
                    <Labeled label="Esta mensagem será enviada na notificação Push:" sx={labeledWidthSx}>
                      <>
                        <TextInput
                          style={{ width: '100%' }}
                          source="notification.pushMessage"
                          label="Mensagem Push"
                          validate={[required(), maxLength(MAX_LENGTH_PUSH)]}
                          InputProps={{ autoComplete: 'off', inputRef: pushInputRef }}
                          onChange={(e) => counterCharInput('push', e.target.value)}
                          helperText={false}
                        />
                        <Box component="span" sx={charCounterSx}>{counterCharPush}/{MAX_LENGTH_PUSH}</Box>
                      </>
                    </Labeled>
                    <Box sx={{ mt: 5 }}>
                      <CustomerNameTagButton inputRef={pushInputRef} />
                    </Box>
                  </Box>
                );
              }
            }}
          </FormDataConsumer>

          <BooleanInput source="notification.sendNow" label="Enviar agora" />
          <FormDataConsumer>
            {({ formData }) => {
              if (formData.notification?.sendNow) {
                return (
                  <Typography variant="subtitle1" gutterBottom>
                    A notificação pode demorar até 10 minutos para ser enviada.
                  </Typography>
                )
              }
            }}
          </FormDataConsumer>

          <FormDataConsumer>
            {({ formData }) => {
              if (!formData.notification?.sendNow) {
                return <DateTimeInputUTC
                  source={"notification.sendAt"}
                  label="Data de Envio"
                  validate={[required(), minValue(
                    nowDatePlus10Minutes(),
                    'A hora de envio deve ser no mínimo 10 minutos apartir de agora',
                  )]}
                  timezone="system"
                />
              }
            }}
          </FormDataConsumer>
        </>
      }
    </>
  );
};

export default React.memo(FormNotification);